export default "__VITE_ASSET__BothavK1__"